<template>
  <pie-chart :data="estatisticas" :donut="true" height="200px"></pie-chart>
</template>

<script>
export default {
  data: () => ({}),
  props: ["estatisticas"],
  watch: {
    atualizaGrafico: function() {
      this.estatisticas;
    }
  }
};
</script>

<style>
</style>